import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import './MoreActions.scss';

function MoreActions({ listItems }) {
  return (
    <DropdownButton
      variant="more-options"
      title="More Actions"
      id="more-options-dropdown"
    >
      {listItems.map((item, i) => <Dropdown.Item as="li" key={`item-${i}`} role="presentation">{item}</Dropdown.Item>)}
    </DropdownButton>
  );
}

MoreActions.propTypes = {
  listItems: PropTypes.arrayOf(PropTypes.element).isRequired,
};

MoreActions.defaultProps = {};

export default MoreActions;
